<template>
  <div>
    <button
      @click="toggleContent"
      class="cursor-pointer flex justify-between items-center mt-twenty font-body text-darkFont text-16 bg-transparent border-0 w-full"
      data-test="title"
      :data-ec="`${titleDataEc}_collapsable_section`"
      :data-et="showContent ? 'hide_content_title' : 'show_content_title'"
      tabindex="0"
    >
      <span class="flex items-center text-left">
        <slot name="title" />
      </span>
      <span class="content-end mx-sm">
        <ChevronUpIcon
          aria-hidden="false"
          :aria-label="$t('accessibility.hideContent')"
          v-show="showContent"
          size="2x"
        />
        <ChevronDownIcon
          aria-hidden="false"
          :aria-label="$t('accessibility.showContent')"
          v-show="!showContent"
          size="2x"
        />
      </span>
    </button>
    <div v-if="showContent" class="mt-twenty" data-test="content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
import { ChevronDownIcon, ChevronUpIcon } from '@/components/icons/fontIcons';

export default {
  name: 'CollapsibleSection',
  components: {
    ChevronDownIcon,
    ChevronUpIcon,
  },
  props: {
    titleDataEc: {
      type: String,
      required: true,
    },
    showOnLoad: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  created() {
    this.showContent = this.showOnLoad;
  },
  data() {
    return {
      showContent: false,
    };
  },
  methods: {
    toggleContent() {
      this.showContent = !this.showContent;
    },
  },
};
</script>
